import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { TagIcon } from "modules/icons";
import CircularIconButton from "modules/_shared/buttons/circular-icon-button";
import { HASH_KEY } from "modules/utils/Constants";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";

interface IProps {
  draftId: string;
  appendText: (value: string) => void;
}

const ComposeBottomToolbarTagButton = ({ draftId, appendText }: IProps) => {
  const { draft, isDraftLoaded, bottomButtonTypes } = useMessageThreadDraft({
    draftId,
  });

  const onClick = useCallback(() => {
    appendText(HASH_KEY);
  }, [appendText]);

  if (!draft || !isDraftLoaded) return null;

  if (!bottomButtonTypes.includes("tag")) {
    return null;
  }

  return (
    <CircularIconButton
      title="Add tag"
      size="xs"
      variant="ghost"
      color={colors.gray40}
      icon={<TagIcon boxSize={5} fill={colors.gray40} />}
      onClick={onClick}
      tabIndex={-1}
      aria-label="Add tag"
    />
  );
};

export default memo(ComposeBottomToolbarTagButton);
